import {
  idDocumentValidators,
  type IdDocumentType,
} from '~domains/profile/entities/person';

import { InputMaskedProps } from '@breezeventures/web-ph-components/input-masked';

export type DocumentMeta = {
  validators: { pattern: { value: RegExp; message: string } };
  maskitoOptions: InputMaskedProps['maskitoOptions'];
  placeholder: string;
  label: string;
};

export const documentMetaMap: Record<IdDocumentType, DocumentMeta> = {
  UMID: {
    validators: idDocumentValidators.UMID,
    placeholder: '0000-0000000-0',
    maskitoOptions: {
      mask: [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
      ],
    },
    label: 'CRN (Common Reference Number)',
  },
  PHIL_ID: {
    validators: idDocumentValidators.PHIL_ID,
    placeholder: '0000-0000-0000-0000',
    maskitoOptions: {
      mask: [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ],
    },
    label: 'PSN (PhilSys Number)',
  },
  PHIL_SYS_ID: {
    validators: idDocumentValidators.PHIL_SYS_ID,
    placeholder: '0000-0000-0000-0000',
    maskitoOptions: {
      mask: [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ],
    },
    label: 'PhilSys ID number',
  },
  DIGITAL_NATIONAL_PHIL_ID: {
    validators: idDocumentValidators.DIGITAL_NATIONAL_PHIL_ID,
    placeholder: '0000-0000-0000-0000',
    maskitoOptions: {
      mask: [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ],
    },
    label: 'Digital national ID number',
  },
  E_PHIL_ID: {
    validators: idDocumentValidators.E_PHIL_ID,
    placeholder: '0000-0000-0000-0000',
    maskitoOptions: {
      mask: [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ],
    },
    label: 'ePhil ID number',
  },
  PRC: {
    validators: idDocumentValidators.PRC,
    placeholder: '0000000',
    maskitoOptions: {
      mask: Array(7).fill(/\d/),
    },
    label: 'PRC license number',
  },
  DRIVING_LICENSE: {
    validators: idDocumentValidators.DRIVING_LICENSE,
    placeholder: 'A00-00-000000',
    maskitoOptions: {
      mask: [
        /[A-Za-z]/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ],
      postprocessors: [
        (elementState) => ({
          ...elementState,
          value: elementState.value.toUpperCase(),
        }),
      ],
    },
    label: 'License number',
  },
  PASSPORT: {
    validators: idDocumentValidators.PASSPORT,
    placeholder: 'A0000000A',
    maskitoOptions: {
      mask: [/[A-Za-z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /[A-Za-z]/],
      postprocessors: [
        (elementState) => ({
          ...elementState,
          value: elementState.value.toUpperCase(),
        }),
      ],
    },
    label: 'Passport number',
  },
  SSS: {
    validators: idDocumentValidators.SSS,
    placeholder: '00-0000000-0',
    maskitoOptions: {
      mask: [
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
      ],
    },
    label: 'SSS Number',
  },
  MY_SSS: {
    validators: idDocumentValidators.MY_SSS,
    placeholder: '00-0000000-0',
    maskitoOptions: {
      mask: [
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
      ],
    },
    label: 'MySSS Number',
  },
  POSTAL_ID: {
    validators: idDocumentValidators.POSTAL_ID,
    placeholder: 'A00000000000',
    maskitoOptions: {
      mask: Array(12).fill(/[\dA-Za-zÑñ]/),
      postprocessors: [
        (elementState) => ({
          ...elementState,
          value: elementState.value.toUpperCase(),
        }),
      ],
    },
    label: 'Postal ID',
  },
};
